import {Component, computed, input, output} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ArchiveIcon, CheckIcon, CoinsIcon, LucideAngularModule, PiggyBankIcon, SquarePenIcon} from 'lucide-angular';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';
import {ActivityPricePipe} from '@domain/activity/pipe/activity-price.pipe';

@Component({
  selector: 'app-activity-price',
  providers: [
    VenuePipe
  ],
  imports: [
    TranslocoDirective,
    LucideAngularModule,
    ActivityPricePipe
  ],
  templateUrl: './activity-price.component.html'
})
export class ActivityPriceComponent {

  public readonly activity = input.required<ActivityDTO | null>();
  public readonly canEdit = input(false);

  public readonly edit = output<void>();

  public readonly icons = {
    coins: CoinsIcon,
    free: PiggyBankIcon,
    check: CheckIcon,
    edit: SquarePenIcon
  };

  public readonly isRecurrent = computed(() => !!this.activity()?.schedules?.some(s => !!s.recurringUnit));
  public readonly hasPrice = computed(() => {
    return ([true, false] as any).includes(this.activity()?.isFree);
  });

  public editClick(): void {
    this.edit.emit();
  }

}
